import { useEffect, useState } from 'react';
import { Link, useParams, useNavigate } from 'react-router-dom';
import type { TrophySet } from '@plathunt/types';
import { useApi } from '../app/providers.js';

/**
 * /game/:gameId ist die Game-Identitaet.
 * Genau ein Set -> direkt weiterleiten. Mehrere Sets -> Set-Auswahl.
 * Sets werden niemals zusammengefuehrt.
 */
export function GameSetPicker() {
  const { gameId } = useParams();
  const api = useApi();
  const navigate = useNavigate();
  const [sets, setSets] = useState<TrophySet[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!gameId) return;
    let cancelled = false;
    api.games
      .getGameTrophySets(gameId)
      .then((value) => {
        if (cancelled) return;
        setSets(value);
        if (value.length === 1) {
          navigate(`/game/${gameId}/set/${value[0]!.id}`, { replace: true });
        }
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, [api, gameId, navigate]);

  if (loading) {
    return (
      <section aria-busy="true">
        <div className="ph-skeleton ph-skeleton--title" />
        <div className="ph-skeleton ph-skeleton--block" />
      </section>
    );
  }

  if (sets.length === 0) {
    return (
      <section>
        <h1 className="ph-screen__title">Trophy Set noch nicht verfügbar</h1>
        <p className="ph-screen__note">
          Das Spiel ist im Katalog, ein Trophy Set wurde aber noch nicht entdeckt.
        </p>
      </section>
    );
  }

  return (
    <section>
      <h1 className="ph-screen__title">Version wählen</h1>
      <p className="ph-screen__note">
        Jede Plattform und jede Region ist ein eigenes Trophy Set mit eigenem Fortschritt. Sie
        werden nicht zusammengerechnet.
      </p>
      <div className="ph-card">
        {sets.map((set) => (
          <Link key={set.id} className="ph-row" to={`/game/${gameId}/set/${set.id}`}>
            {set.title}
            <div className="ph-muted">
              {set.platform.toUpperCase()} · {set.region.toUpperCase()}
              {set.version ? ` · v${set.version}` : ''} · {set.trophyCount.total} Trophäen
              {set.hasPlatinum ? ' · Platin' : ' · kein Platin'}
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}
